import { render, staticRenderFns } from "./CopyQuoteModal.vue?vue&type=template&id=b5cd3fbc&scoped=true"
import script from "./CopyQuoteModal.vue?vue&type=script&lang=js"
export * from "./CopyQuoteModal.vue?vue&type=script&lang=js"
import style0 from "./CopyQuoteModal.vue?vue&type=style&index=0&id=b5cd3fbc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cd3fbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5cd3fbc')) {
      api.createRecord('b5cd3fbc', component.options)
    } else {
      api.reload('b5cd3fbc', component.options)
    }
    module.hot.accept("./CopyQuoteModal.vue?vue&type=template&id=b5cd3fbc&scoped=true", function () {
      api.rerender('b5cd3fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/CopyQuoteModal.vue"
export default component.exports